import { Observable } from 'rxjs/Rx'
import { Record } from 'immutable'
import { combineEpics } from 'redux-observable'
import { assign } from 'lodash'
import { mergeMap } from 'rxjs/operators'

import { INIT } from '../../constants/phase'
import { ofType } from 'redux-observable'
import Config from '../../config'
import { SecureStorage } from '../../utils'
import * as api from './api'

/***********************************
 * Action Types
 ***********/

export const BARCODE = 'cozy/user/BARCODE'
export const BARCODE_SUCCESS = 'cozy/user/BARCODE_SUCCESS'
export const BARCODE_ERROR = 'cozy/user/BARCODE_ERROR'

export const FETCH_ROOMS = 'cozy/user/FETCH_ROOMS'
export const FETCH_ROOMS_SUCCESS = 'cozy/user/FETCH_ROOMS_SUCCESS'
export const FETCH_ROOMS_ERROR = 'cozy/user/FETCH_ROOMS_ERROR'

export const FETCH_ROOM = 'cozy/user/FETCH_ROOM'
export const FETCH_ROOM_SUCCESS = 'cozy/user/FETCH_ROOM_SUCCESS'
export const FETCH_ROOM_ERROR = 'cozy/user/FETCH_ROOM_ERROR'

export const SET_TEMPERATURE = 'cozy/user/SET_TEMPERATURE'
export const SET_TEMPERATURE_SUCCESS = 'cozy/user/SET_TEMPERATURE_SUCCESS'
export const SET_TEMPERATURE_ERROR = 'cozy/user/SET_TEMPERATURE_ERROR'

export const SET_SCHEDULE = 'cozy/user/SET_SCHEDULE'
export const SET_SCHEDULE_SUCCESS = 'cozy/user/SET_SCHEDULE_SUCCESS'
export const SET_SCHEDULE_ERROR = 'cozy/user/SET_SCHEDULE_ERROR'

export const SET_POINT = 'cozy/user/SET_POINT'
export const SET_POINT_SUCCESS = 'cozy/user/SET_POINT_SUCCESS'
export const SET_POINT_ERROR = 'cozy/user/SET_POINT_ERROR'

export const SET_NICK_NAME = 'cozy/user/SET_NICK_NAME'
export const SET_NICK_NAME_SUCCESS = 'cozy/user/SET_NICK_NAME_SUCCESS'
export const SET_NICK_NAME_ERROR = 'cozy/user/SET_NICK_NAME_ERROR'

export const CLEAR_COZY_PROPS = 'cozy/user/CLEAR_COZY_PROPS'
export const RESET_COZY = 'cozy/user/RESET_COZY'


/***********************************
 * Initial State
 ***********/

// Unlike other ducks we are taking a class style approach
// for creating the InitialState. This is becuase we need to fetch the
// locally stored token in the constructor when it is created
const InitialStateInterface = {
  token: null,  // We need this here to tell InitialState that there is a token key,
                // but it will be reset below to what is in localStorage, unless a value
                // is passed in when the object is instanciated
  barcodeSuccess: null,
  rooms: null,
  phase: INIT,
  room: null,
  setPoints: false,
  setTemperatures: false,
  schedules: null,
  setScheduleSuccess: false,
  setNick: false,
  isRoom: true
}
class InitialState extends Record(InitialStateInterface) {
  constructor(desiredValues) {
    // When we construct InitialState, we automatically update it's default value
    // for token to be what is stored in localStorage
    const token = localStorage.getItem(Config.LocalStorageKeys.Authorization)
    super(assign({ token }, desiredValues))
  }
}

/***********************************
 * Reducer
 ***********/

// eslint-disable-next-line complexity, max-statements
export default function (state = new InitialState(), action = {}) {

  switch (action.type) {
    case BARCODE_SUCCESS: {
      const { payload } = action
      return state
        .set('barcodeSuccess', payload)
    }
    case FETCH_ROOMS_SUCCESS: {
      const { payload } = action
      return state
        .set('rooms', payload.data.rooms)
        .set('setTemperatures', false)
        .set('setScheduleSuccess', false)
        .set('isRoom', true)
    }
    case FETCH_ROOMS: {
      return state
        .set('isRoom', false)
    }
    case FETCH_ROOMS_ERROR: {
      /* Return Encrypted local data when no internet */
      if (!navigator.onLine) {
        /**
        Stored secure encrypted data decode
        **/
        const secureData = localStorage.getItem(Config.LocalStorageKeys.Rooms)
        const data = secureData ? SecureStorage.decrypt(secureData) : []
        
        const rooms = JSON.parse(data)
        return state
          .set('rooms', rooms.data.rooms)
      }
      return state
        .set('room', [])
    }
    case FETCH_ROOM_SUCCESS: {
      const { payload } = action
      return state
        .set('room', payload.data.room)
        .set('setTemperatures', false)
        .set('setScheduleSuccess', false)
    }
    case FETCH_ROOM_ERROR: {
      /* Return Encrypted local data when no internet */
      if (!navigator.onLine) {
        /**
        Stored secure encrypted data decode
        **/
        const secureData = localStorage.getItem(Config.LocalStorageKeys.Room)
        const data = secureData ? SecureStorage.decrypt(secureData) : []
        
        const room = JSON.parse(data)
        return state
          .set('room', room.data.room)
          .set('setTemperatures', false)
      }
      return state
        .set('room', [])
        .set('setTemperatures', false)
    }
    case SET_TEMPERATURE_SUCCESS: {
      return state
        .set('setTemperatures', true)
    }
    case SET_TEMPERATURE: {
      return state
        .set('setTemperatures', false)
    }
    case SET_POINT_SUCCESS: {
      const { payload } = action
      return state
        .set('setPoints', payload)
    }
    case SET_SCHEDULE_SUCCESS: {
      const { payload } = action
      return state
        .set('schedules', payload.data.setSchedule)
        .set('setScheduleSuccess', true)
    }
    case SET_SCHEDULE: {
      return state
        .set('setScheduleSuccess', false)
    }
    case CLEAR_COZY_PROPS: {
      return state
        .set('setPoints', false)
        .set('setTemperatures', false)
        .set('schedules', null)
        .set('setScheduleSuccess', false)
        .set('setNick', false)
    }
    case RESET_COZY: {
      return new InitialState()
    }
    case SET_NICK_NAME: {
      return state
        .set('setNick', false)
    }
    case SET_NICK_NAME_SUCCESS: {
      return state
        .set('setNick', true)
    }

    default: {
      return state
    }
  }

}


/***********************************
 * Action Creators
 ***********/

export const submitBarcode = (payload) => {
  return {
    type: BARCODE,
    payload
  }
}

export const fetchRooms = (payload) => {
  return {
    type: FETCH_ROOMS,
    payload
  }
}

export const setTemperature = (payload) => {
  return {
    type: SET_TEMPERATURE,
    payload
  }
}

export const setSchedule = (payload) => {
  return {
    type: SET_SCHEDULE,
    payload
  }
}

export const fetchRoom = (payload) => {
  return {
    type: FETCH_ROOM,
    payload
  }
}

export const setSetPoint = (payload) => {
  return {
    type: SET_POINT,
    payload
  }
}

export const setNickName = (payload) => {
  return {
    type: SET_NICK_NAME,
    payload
  }
}

export const clearCozyProps = () => {
  return {
    type: CLEAR_COZY_PROPS
  }
}

export const resetCozy = () => {
  return {
    type: RESET_COZY
  }
}

/***********************************
 * Epics
 ***********************************/

const submitBarcodeEpic = action$ =>
  action$.pipe(
    ofType(BARCODE),
    mergeMap(action => {
      return Observable.from(api.submitBarcode(action.payload))
      .flatMap(payload => [{
        type: BARCODE_SUCCESS,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: BARCODE_ERROR,
          payload: { error }
        })
      )
    })
  )

const fetchRoomsEpic = action$ =>
  action$.pipe(
    ofType(FETCH_ROOMS),
    mergeMap(action => {
      return Observable.from(api.fetchRooms())
      .flatMap(payload => [{
        type: FETCH_ROOMS_SUCCESS,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: FETCH_ROOMS_ERROR,
          payload: { error }
        })
      )
    })
  )

const setTemperatureEpic = action$ =>
  action$.pipe(
    ofType(SET_TEMPERATURE),
    mergeMap(action => {
      return Observable.from(api.setTemperature(action.payload))
      .flatMap(payload => [{
        type: SET_TEMPERATURE_SUCCESS,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: SET_TEMPERATURE_ERROR,
          payload: { error }
        })
      )
    })
  )

const setScheduleEpic = action$ =>
  action$.pipe(
    ofType(SET_SCHEDULE),
    mergeMap(action => {
      return Observable.from(api.setSchedule(action.payload))
      .flatMap(payload => [{
        type: SET_SCHEDULE_SUCCESS,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: SET_SCHEDULE_ERROR,
          payload: { error }
        })
      )
    })
  )

const fetchRoomEpic = action$ =>
  action$.pipe(
    ofType(FETCH_ROOM),
    mergeMap(action => {
      return Observable.from(api.fetchRoom(action.payload))
      .flatMap(payload => [{
        type: FETCH_ROOM_SUCCESS,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: FETCH_ROOM_ERROR,
          payload: { error }
        })
      )
    })
  )

const setSetPointEpic = action$ =>
  action$.pipe(
    ofType(SET_POINT),
    mergeMap(action => {
      return Observable.from(api.setSetPoint(action.payload))
      .flatMap(payload => [{
        type: SET_POINT_SUCCESS,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: SET_POINT_ERROR,
          payload: { error }
        })
      )
    })
  )

const setNickNameEpic = action$ =>
  action$.pipe(
    ofType(SET_NICK_NAME),
    mergeMap(action => {
      return Observable.from(api.setNickName(action.payload))
      .flatMap(payload => [{
        type: SET_NICK_NAME_SUCCESS,
        payload
      }])
      .catch(error =>
        Observable.of({
          type: SET_NICK_NAME_ERROR,
          payload: { error }
        })
      )
    })
  )

export const cozyEpic = combineEpics(
  submitBarcodeEpic,
  fetchRoomsEpic,
  setTemperatureEpic,
  setScheduleEpic,
  fetchRoomEpic,
  setSetPointEpic,
  setNickNameEpic
)



// WEBPACK FOOTER //
// ./src/store/cozy/duck.js